import './Footer.css';
import NiceModal from '@ebay/nice-modal-react';
import LogoutModal from '/src/features/auth/components/LogoutModal/LogoutModal';
import { useNavigate } from 'react-router-dom';
import { useAuthStateContext } from '/src/features/auth/context/authContext';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import { NavLink } from 'react-router-dom';
import { removeStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';

function Footer() {

    const { user } = useAuthStateContext();

    const naviguate = useNavigate()
    const dispatch = useAuthDispatchContext();

    const showLogoutModal = () => NiceModal.show(LogoutModal).then(() => {
        removeStorageParamForCurrentCompany('conversation_filters');
        sessionStorage.removeItem('user');
        localStorage.removeItem('token');
        dispatch({ type : 'loginOut'});
        naviguate('/login')
    })

    return (
        <div className="footer">
            <div className="user">
                <NavLink to="user/settings">
                    <img className="user-image" src={user.picture}></img>
                </NavLink>
                <span>
                    <NavLink to="user/settings">
                        <var data-var="user-name" id="user-name">{user.username}</var>
                    </NavLink>
                </span>
                {!user?.external_id && (
                    <button id="sidebar-disconnect">
                        <div className='svg logout' onClick={showLogoutModal}></div>
                    </button>
                )}
            </div>
        </div>
    )
}

export default Footer;